// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"582cf3a6","453":"d4f7676d"}[chunkId] + ".chunk.js";
};